<template>
  <div>
    <div class="memberInfo">
      <img
        src="../image/headIconBg.png"
        style="width:4.65rem;height: 3.54rem;"
      />
      <img
        :src="imgBaseUrl + vipInfo.matchFaceImg"
        style="width:1.2rem;height:1.2rem;position:absolute;left:1.73rem;top:0.76rem;border-radius: 50%;"
      />
      <div
        style="position:absolute;left:50%;top:2.33rem;transform:translateX(-50%);font-size: 0.28rem;font-weight:bold;color: #4F3D3E;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width: 3rem;text-align:center;"
      >
        {{ vipInfo.name }}
      </div>
      <div
        style="position:absolute;left:50%;top:2.9rem;transform:translateX(-50%);font-size: 0.22rem;font-weight: 400;color: #4F3D3E;"
      >
        到期时间：{{ vipInfo.expirationTime }}
      </div>
      <div class="infoBottom">
        <div class="infoItem">
          <div class="infoValue">{{ vipInfo.integralTotal }}</div>
          <div class="infoLabel">剩余积分</div>
        </div>
        <div class="line"></div>
        <div class="infoItem">
          <div class="infoValue">{{ vipInfo.inviteCode }}</div>
          <div class="infoLabel">邀请码</div>
        </div>
      </div>
      <div class="infoBtn" @click="toMemberPage">
        立即续费
      </div>
    </div>
    <div class="memberTab">
      <div
        :class="{ tabItem: true, active: active === 1 }"
        @click="$router.push('/member/memberMall')"
      >
        礼品商城
      </div>
      <div
        :class="{ tabItem: true, active: active === 2 }"
        @click="$router.push('/member/memberWelfare')"
      >
        我的福利
      </div>
      <div
        :class="{ tabItem: true, active: active === 3 }"
        @click="$router.push('/member/memberOrder')"
      >
        我的订单
      </div>
      <div
        :class="{ tabItem: true, active: active === 4 }"
        @click="$router.push('/member/memberIntegral')"
      >
        我的积分
      </div>
    </div>
  </div>
</template>

<script>
import { visitorInfo } from "@/api/member/index.js";
export default {
  data() {
    return {
      vipInfo: {},
      imgBaseUrl: process.env.VUE_APP_IMG_URL
    };
  },
  props: ["active"],
  created() {
    this.getVipInfo();
  },
  methods: {
    toMemberPage() {
      this.$router.push('/member/member')
    },
    getVipInfo() {
      visitorInfo().then(res => {
        if (res.data.code == 0) {
          this.$emit("getExpirationTime", this.timeFormatSeconds(res.data.data.expirationTime));
          res.data.data.expirationTime = this.timeFormatDate(
            res.data.data.expirationTime
          );
          this.vipInfo = res.data.data;
        }
      });
    },
    timeFormatDate(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      return year + "-" + month + "-" + day;
    },
    timeFormatSeconds(time) {
      var d = time ? new Date(time) : new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var day = d.getDate();
      var hours = d.getHours();
      var min = d.getMinutes();
      var seconds = d.getSeconds();

      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      if (hours < 10) hours = "0" + hours;
      if (min < 10) min = "0" + min;
      if (seconds < 10) seconds = "0" + seconds;

      return (
        year + "-" + month + "-" + day + " " + hours + ":" + min + ":" + seconds
      );
    }
  }
};
</script>

<style scoped>
.leftBox {
  width: 4.65rem;
  border-radius: 0.15rem 0.15rem 0 0;
  overflow: hidden;
  margin-right: 0.25rem;
}

.memberInfo {
  width: 4.65rem;
  height: 6.8rem;
  background-color: #4f3d3e;
  position: relative;
}

.infoBottom {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.4rem;
}

.infoItem {
  color: #d5d2d2;
}

.line {
  width: 0.01rem;
  height: 0.8rem;
  background: #d5d2d2;
  opacity: 0.4;
}

.infoValue {
  text-align: center;
  font-size: 0.38rem;
  font-weight: bold;
}

.infoLabel {
  text-align: center;
  font-size: 0.26rem;
  margin-top: 0.16rem;
}

.infoBtn {
  font-size: 0.38rem;
  color: #4f3d3e;
  background-color: #ffcfa3;
  width: 3.8rem;
  padding: 0.1rem;
  text-align: center;
  border-radius: 0.6rem;
  margin: 0.45rem auto 0 auto;
}

.tabItem {
  width: 4.57rem;
  height: 1.13rem;
  line-height: 1.13rem;
  font-size: 0.28rem;
  font-weight: 400;
  color: #333333;
  text-align: center;
  border-left: 0.08rem solid #fff;
  background: #ffffff;
}

.active {
  border-left: 0.08rem solid #ee554e;
  color: #ee554e;
  background: #fef6f6;
}
</style>



// WEBPACK FOOTER //
// src/views/member/components/memberInfo.vue